import React, { useEffect, useState } from "react";
import api from "../api";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFormattedNumbers from "../../hooks/useFormattedNumber";

const TreeCensus = () => {
  const { i18n, t } = useTranslation();
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const numbers = treeData.map((_, index) => index + 1);
  const formattedNumbers = useFormattedNumbers(numbers);
  useEffect(() => {
    api
      .get(`/tree-census?lang=${i18n.language}`)
      .then((response) => {
        setTreeData(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching tree census data:", err);
        setError("Error loading data");
        setLoading(false);
      });
  }, [i18n.language]);

  return (
    <>
      <section className="page-title">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${innerBanner})`,
          }}
        ></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{t("tree-contents.treeCensus")}</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="#.">{t("cityProfile")}</Link>
              </li>
              <li>
                <span>{t("tree-contents.treeCensus")}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div id="main-content">
      <br />
      <section className="service-style-four mt-5">
        <div className="auto-container">
          <h5 className="pb-4">
            {t("tree-contents.treeStatement")}
          </h5>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="text-center">
                <tr>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("srNo")}
                  </th>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("description")}
                  </th>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("total")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      {t("loading")}
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan="3" className="text-center text-danger">
                      {error}
                    </td>
                  </tr>
                ) : (
                  treeData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{formattedNumbers[index]}</td>
                      <td>{item.description}</td>
                      <td>{item.total}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default TreeCensus;
